import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { PatrolListHeader } from "./PatrolListHeader";
import { PatrolSearchBar } from "./PatrolSearchBar";
import { PatrolEmptyState } from "./PatrolEmptyState";
import { PatrolListView } from "./PatrolListView";
import { PatrolFolderView } from "./PatrolFolderView";
import LoaderComponent from "../../../components/LoaderComponent";

export function PatrolList({
  loader = false,
  totalCount = 15,
  currentCount = 0,
  searchQuery = "",
  onSearchChange,
  dateFilter = "Last 7 Days",
  fromDate,
  toDate,
  onDateFilterChange,
  onCalendarClick,
  onMenuClick,
  onFilterClick,
  onViewClick,
  activeButton = "list",
  patrols = [],
  selectedPatrolId = null,
  onPatrolClick,
  onActionClick,
  columnVisibility = { id: true, action: true },
  onSettingsClick,
  isSettingsOpen = false,
  selectedDrawingForView,
  onSelectDrawing,
  onClearSelectedDrawing,
  /** When true, table/folder shows even without My Drawings selection (local JSON fixture). */
  showListWithoutDrawing = false,
}) {
  // const hasPatrols = patrols && patrols.length > 0;
  const hasPatrols = patrols && patrols.length > 0;

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "white",
        border: "1px solid",
        borderColor: "#E5E7EB",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <PatrolListHeader
        totalCount={totalCount}
        currentCount={currentCount}
        selectedDrawingForView={selectedDrawingForView}
        onSelectDrawing={onSelectDrawing}
        onClearSelectedDrawing={onClearSelectedDrawing}
        dateFilter={dateFilter}
        fromDate={fromDate}
        toDate={toDate}
        onDateFilterChange={onDateFilterChange}
        onSettingsClick={onSettingsClick}
        isSettingsOpen={isSettingsOpen}
      />

      {/* Search and Filter Bar */}
      <PatrolSearchBar
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        onMenuClick={onMenuClick}
        onFilterClick={onFilterClick}
        onViewClick={onViewClick}
        activeButton={activeButton}
      />
      {/* Content Area */}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!selectedDrawingForView?.id && !showListWithoutDrawing ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Roboto, sans-serif",
                fontSize: "14px",
                color: "#4A5565",
                textAlign: "center",
                maxWidth: 420,
              }}
            >
              No drawing selected. Choose a drawing in My Drawings to view patrol
              sessions for that plan.
            </Typography>
          </Box>
        ) : loader ? <LoaderComponent /> :
        hasPatrols && !loader ? (
          <>
            {activeButton === "list" ? (
              <PatrolListView
                patrols={patrols}
                selectedPatrolId={selectedPatrolId}
                onPatrolClick={onPatrolClick}
                onActionClick={onActionClick}
                columnVisibility={columnVisibility}
              />
            ) : (
              <PatrolFolderView
                patrols={patrols}
                selectedPatrolId={selectedPatrolId}
                onPatrolClick={onPatrolClick}
                onActionClick={onActionClick}
                groupBy={activeButton === "path" ? "drawingPath" : "drawingName"}
                isComparePatrol={false}
              />
            )}
          </>
        ) : (
          <PatrolEmptyState />
        )
        }
        
      </Box>
    </Paper>
  );
}

